/* ---- SCR-002: Event history page ---- */

import { renderEventCard } from '../components/EventCard';
import { type SearchFormValues, renderSearchForm } from '../components/SearchForm';
import { MOCK_EVENTS } from '../mocks/events';
import { eventService } from '../services/event.service';
import type { EventItem } from '../types';

export class HistoryPage {
  private el: HTMLElement;
  private events: EventItem[] = [];
  private onSelectEvent: (eventId: number) => void;

  constructor(onSelectEvent: (eventId: number) => void) {
    this.el = document.createElement('div');
    this.el.className = 'screen';
    this.onSelectEvent = onSelectEvent;
  }

  render(): HTMLElement {
    this.el.innerHTML = '';

    // Header
    const header = document.createElement('div');
    header.className = 'sh';
    header.innerHTML = '<h1>イベント履歴</h1>';
    this.el.appendChild(header);

    // Search form
    const searchForm = renderSearchForm((values) => this.doSearch(values));
    this.el.appendChild(searchForm);

    // Results container
    const results = document.createElement('div');
    results.className = 'rs';
    results.id = 'history-results';
    this.el.appendChild(results);

    // Load initial data
    this.loadEvents();

    return this.el;
  }

  private async loadEvents(params?: SearchFormValues): Promise<void> {
    const results = this.el.querySelector('#history-results')!;
    results.innerHTML = '<div class="loading"><div class="spinner"></div></div>';

    try {
      const res = await eventService.listEvents({
        fence_name: params?.fenceName || undefined,
        date: params?.date || undefined,
        type: params?.type || undefined,
      });
      this.events = res.events;
    } catch {
      // Fallback to mock data
      this.events = [...MOCK_EVENTS];
      if (params?.fenceName) {
        this.events = this.events.filter((e) => e.fence.includes(params.fenceName));
      }
      if (params?.date) {
        this.events = this.events.filter((e) => e.date.startsWith(params.date));
      }
      if (params?.type) {
        this.events = this.events.filter((e) => e.type === params.type);
      }
    }

    this.renderResults();
  }

  private renderResults(): void {
    const results = this.el.querySelector('#history-results')!;
    results.innerHTML = '';

    if (this.events.length === 0) {
      results.innerHTML = '<div class="em">該当するイベントがありません</div>';
      return;
    }

    this.events.forEach((event) => {
      const card = renderEventCard(event, () => this.onSelectEvent(event.id));
      results.appendChild(card);
    });
  }

  private doSearch(values: SearchFormValues): void {
    this.loadEvents(values);
  }

  /** Get event data by ID (for detail page) */
  getEventById(id: number): EventItem | undefined {
    return this.events.find((e) => e.id === id);
  }
}
